import { save_jpeg_image_base64 } from '@kk/h5-sdk';
import Toast from '@kk/toast';

/**
 * @param {string} base64
 */
export function saveImage(base64) {
    localStorage.removeItem('saveImgBase');
    save_jpeg_image_base64({
        img: base64,
        callback: (/** @type {{ code: number; }} */ res) => {
            loading.hide();
            if (res.code === 200) {
                Toast.show({
                    text: '图片保存成功，可在手机相册中查看',
                    time: 2000,
                });
            } else {
                Toast.show({
                    text: '图片保存失败',
                    time: 2000,
                });
            }
            localStorage.removeItem('saveImgBase');
        },
    });
}
